import { useCallback, useState } from 'react';
import CardInfoItem from 'src/components/CardInfoItem';
import Toolbar from 'src/components/Toolbar';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Button, { ButtonTypes } from 'src/components/Button';
import forwardIcon from 'src/assets/forward_white.svg';
import { confirmQuitFlow } from 'src/utils';
import cancerStore, { CancerStore } from 'src/stores/CancerStore';
import { observer } from 'mobx-react-lite';
import PopupService from 'src/utils/PopupService';
import { gaTrackEvent } from '../../api';
import { BUYING_PROCESS, BUYING_PROCESS_STEP, BUYING_PROCESS_TRACKING } from '../../constants';
import UserInfoService from '../../utils/UserInfoService';

interface HealthQuestionObserverProps {
  cancerStore?: CancerStore;
}
const HealthQuestionObserver = observer(
  ({ cancerStore }: HealthQuestionObserverProps) => {
    const { t } = useTranslation();
    const history = useHistory();
    const [isAgress, setIsAgress] = useState<boolean>(
      typeof cancerStore.formInfo?.isAgreeHealth != 'undefined'
        ? cancerStore.formInfo?.isAgreeHealth
        : null
    );

    const _handleContinue = useCallback(() => {
      console.log('IsAgress', isAgress);
      if (typeof isAgress === 'undefined' || isAgress === null) {
        PopupService.instance.current.open({
          visible: true,
          title: t('notification'),
          content: t('please_answer_health_question'),
          okTitle: t('close'),
          onOk: () => {
            PopupService.instance.current.close();
          },
          showIcon: false,
        });
      } else if (isAgress === true) {

        gaTrackEvent(BUYING_PROCESS_TRACKING,
          BUYING_PROCESS[BUYING_PROCESS_STEP.AnswerHealthQuestion_Yes].name,
          UserInfoService.getUserInfo()?.idCardNo ?? "");

        PopupService.instance.current.open({
          visible: true,
          title: t('notification'),
          content: t('we_cant_accept_your_insurance_request'),
          cancelTitle: t('later'),
          showContactButton: true,
          hotline: t('hotline2'),
          onOk: () => {
            PopupService.instance.current.close();
          },
          onCancel: () => {
            PopupService.instance.current.close();
          },
        });
      } else {
        cancerStore.updateFormInfo({
          isAgreeHealth: isAgress,
        });

        gaTrackEvent(BUYING_PROCESS_TRACKING,
          BUYING_PROCESS[BUYING_PROCESS_STEP.AnswerHealthQuestion_No].name,
          UserInfoService.getUserInfo()?.idCardNo ?? "");

        history.push('/buy-insurance/cancer/confirm-customer-info');
      }
    }, [history, t, isAgress]);

    const _handleClose = () => {
      confirmQuitFlow(history);
    };

    const _handleYes = () => {
      console.log('_handleYes');
      setIsAgress(true);
    };

    const _handleNo = () => {
      console.log('_handleNo');
      setIsAgress(false);
    };

    const _handleBack = () => {
      history.goBack();
      cancerStore.updateFormInfo({ isAgreeHealth: null });
    };

    return (
      <div className="screen-container bg-background">
        <Toolbar
          title={t('health_question')}
          type="normal"
          showClose={true}
          onClose={_handleClose}
          onBack={_handleBack}
        />
        <div className="p-4 screenScrollContainer pb-16">
          {cancerStore.questions.map((item) => (
            <div className="mb-4" key={item.id}>
              <CardInfoItem
                title={`${t('question')} ${item.id}`}
                info={item.name}
              />
            </div>
          ))}
        </div>
        <div className="bottomButtonBlock">
          <div className="flex flex-row mb-5">
            <Button
              text={t('yes')}
              buttonType={
                isAgress === true
                  ? ButtonTypes.primaryFilled
                  : ButtonTypes.outlinedNeutral
              }
              onClick={_handleYes}
              extraClassName={'flex-1 mr-3'}
            />
            <Button
              text={t('no')}
              buttonType={
                isAgress === false
                  ? ButtonTypes.primaryFilled
                  : ButtonTypes.outlinedNeutral
              }
              onClick={_handleNo}
              extraClassName={'flex-1'}
            />
          </div>
          <div className="flex flex-row">
            <Button
              text={t('continue')}
              buttonType={ButtonTypes.primaryFilled}
              extraClassName="w-full"
              onClick={_handleContinue}
              rightIcon={<img src={forwardIcon} className="w-6 h-6 ml-2" />}
            />
          </div>
        </div>
      </div>
    );
  }
);

const HealthQuestion = () => (
  <HealthQuestionObserver cancerStore={cancerStore} />
);

export default HealthQuestion;
